/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Table } from 'rsuite';
import { DataTableMenuBtn } from 'types';
import styles from './SclaViewAppCell.module.scss';

interface ISclaViewAppCellProps {
  menuBtn?: DataTableMenuBtn;
}

const { Cell } = Table;

function SclaViewAppCell({
  rowData,
  menuBtn = undefined,
  ...props
}: any & ISclaViewAppCellProps) {
  if (menuBtn) {
    const { label, onClick } = menuBtn;

    return (
      <Cell {...props}>
        <div className={styles.cell}>
          <button
            type="button"
            className={styles.btn}
            onClick={() => onClick(rowData._id)}
          >
            <p>{label} </p>
          </button>
        </div>
      </Cell>
    );
  }

  return (
    <Cell {...props}>
      <div className={styles.cell}>
        <p>View App </p>
      </div>
    </Cell>
  );
}

export default SclaViewAppCell;
